import { useContext } from "react"
import UserContext from "../context/userContext"

export default () => useContext(UserContext);